import styled, { CSSObject } from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

interface CommmonStyle {
    isBlackPlan: boolean;
}

const getTextContainerWidth = (isBlackPlan: boolean) => (isBlackPlan ? "62%" : "60%");
const ANIMATED_TITLE_CONTAINER_WIDTH = "150%";

const BACKGROUND_WIDTH_HEIGHT = "74PX";

const getWidgetBackground = (isBlackPlan = false) =>
    isBlackPlan
        ? `linear-gradient(270deg, #F3E7DE 0%, #FFF 100%)`
        : "linear-gradient(285deg, rgba(241, 91, 107, 0.10) -18.01%, rgba(241, 91, 106, 0.10) 28.51%, rgba(241, 92, 66, 0.10) 64.46%, rgba(248, 154, 75, 0.10) 97.07%)";
const TITLE_BOTTOM_BORDER = "linear-gradient(90deg, rgba(243, 108, 86, 0.50) 0%, rgba(243, 108, 86, 0.00) 100%)";

export const NudgeWrapper = styled.div(() => ({
    paddingTop: "1px",
}));

export const Container = styled.div<CommmonStyle & { isWeb: boolean }>(({ theme, isBlackPlan, isWeb }) => ({
    position: "relative",
    zIndex: 0,
    padding: theme.spacing.small,
    margin: theme.spacing.xxSmall,
    marginBottom: 0,
    background: getWidgetBackground(isBlackPlan),
    borderRadius: `${theme.cornerRadius.small} ${theme.cornerRadius.small} ${
        isBlackPlan ? 0 : theme.cornerRadius.small
    }  ${isBlackPlan ? 0 : theme.cornerRadius.small}`,
    overflow: "hidden",
    ...(isWeb && {
        display: "flex",
        gap: theme.spacing.xSmall,
    }),
}));

export const BlackBackgroundImage = styled.div(({ theme }) => ({
    position: "absolute" as CSSObject["position"],
    zIndex: -1,
    width: BACKGROUND_WIDTH_HEIGHT,
    height: BACKGROUND_WIDTH_HEIGHT,
    bottom: `calc(${theme.spacing.xxSmall} * -1)`,
    right: 0,
}));

export const TextContainer = styled.div<CommmonStyle & { isWeb: boolean }>(({ theme, isBlackPlan, isWeb }) => ({
    width: getTextContainerWidth(isBlackPlan),
    display: "inline-block",
    alignItems: "center",
    marginBottom: theme.spacing.xxxSmall,
    ...(isWeb && {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "flex-start",
    }),
}));

export const BorderLine = styled.div<{ width: number }>(({ width, theme }) => ({
    background: TITLE_BOTTOM_BORDER,
    width: `${width}px`,
    height: theme.spacing.xxxSmall,
}));

export const CtaAndPriceContainer = styled.div<{ isV1Variant: boolean; isWeb: boolean }>(
    ({ isV1Variant, theme, isWeb }) => ({
        display: "flex",
        justifyContent: isWeb ? "flex-end" : "space-between",
        alignItems: "flex-start",
        marginTop: isV1Variant ? theme.spacing.xxSmall : 0,
        width: "100%",
    }),
);

export const Title = styled.div(() => ({
    width: "fit-content",
    display: "flex",
    alignItems: "center",
}));
interface ICartV2 {
    isCartV2?: boolean;
}

export const PriceContainer = styled.div<ICartV2>(({ theme, isCartV2 }) => ({
    display: "flex",
    flexDirection: "column" as CSSObject["flexDirection"],
    justifyContent: "flex-end",
    alignItems: "flex-end",
    marginLeft: isCartV2 ? 0 : theme.spacing.small,
    marginTop: theme.spacing.xxxSmall,
    textAlign: "right" as CSSObject["textAlign"],
    minWidth: "45px",
    ...(isCartV2 && {
        alignSelf: "center",
    }),
}));

export const BasePrice = styled(Text)<CommmonStyle>(({ theme, isBlackPlan }) => ({
    marginBottom: isBlackPlan ? "1px" : theme.spacing.xxSmall,
}));

export const AnimatedTitlesContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xxxSmall,
    width: ANIMATED_TITLE_CONTAINER_WIDTH,
}));
